import { Box } from '@mui/material';

import Filter from '../../../../../../common/reports/actions/utils/filter';
import { reportDetailsFilterValuesFormatter } from '../../../../../../../utils/details';
import { formatDate, TABLE_DATE_TIME_FORMAT } from '../../../../../../../constants/helpers/dates';

import locales from '../locales';
import { WapReportDetailsMetaDataResponse } from '../interfaces';
// eslint-disable-next-line max-len
import { convertWapSessionCloseReasonQueryToReadableFormat } from '../../../../../../common/table/utils/operationTypeFormatters';

interface Props {
  filters: WapReportDetailsMetaDataResponse;
}

const FiltersSummary = ({ filters }: Props) => (
  <Box>
    <Box display="flex" mt={2} mb={2}>
      <Box width="50%">
        <Filter
          label={locales.details.startingDate.label}
          value={formatDate(filters.timeRange.from, TABLE_DATE_TIME_FORMAT)}
        />
      </Box>
      <Box width="50%">
        <Filter
          label={locales.details.endDate.label}
          value={formatDate(filters.timeRange.to, TABLE_DATE_TIME_FORMAT)}
        />
      </Box>
    </Box>
    <Box display="flex" mt={2} mb={2}>
      <Box width="50%">
        <Filter label={locales.details.operators.label} value={reportDetailsFilterValuesFormatter(filters.operators)} />
      </Box>
      <Box width="50%">
        <Filter label={locales.details.appIds.label} value={reportDetailsFilterValuesFormatter(filters.wapAppIds)} />
      </Box>
    </Box>
    <Box display="flex" mt={2} mb={2}>
      <Box width="50%">
        <Filter
          label={locales.details.phoneNumbers.label}
          value={reportDetailsFilterValuesFormatter(filters.msisdns)}
        />
      </Box>
      <Box width="50%">
        <Filter
          label={locales.details.sessionTypes.label}
          value={reportDetailsFilterValuesFormatter(filters.sessionTypes)}
        />
      </Box>
    </Box>
    <Box display="flex" mt={2} mb={2}>
      <Box width="50%">
        <Filter
          label={locales.details.sessionTags.label}
          value={reportDetailsFilterValuesFormatter(filters.sessionTags)}
        />
      </Box>
      <Box width="50%">
        <Filter
          label={locales.details.sessionCloseReasons.label}
          value={reportDetailsFilterValuesFormatter(
            filters.sessionCloseReasons.map(value => convertWapSessionCloseReasonQueryToReadableFormat(value))
          )}
        />
      </Box>
    </Box>
  </Box>
);

export default FiltersSummary;
